var map = {
	"./001_ostov_collective_zlam_plast_ausstellungsansicht_copy.webp": 812,
	"./006_ostov_collective_ua_temporary_store_schaufensteransicht_2.webp": 1674,
	"./007_ostov_collective_zlam_koeln_ausstellungsansicht.webp": 9439,
	"./009_ostov_collective_zlam_hgb_ausstellungsansicht.webp": 5162,
	"./013_ostov_collective_spps_ausstellungsansicht.webp": 8750,
	"./019_ostov_collective_ostov_table_ausstellungsansicht.webp": 2659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7603;